<jhi-navbar *ngIf="!isAdminRoute"></jhi-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!isAdminRoute"></app-footer>
